import type { DemoLeadValues } from '@/components/DemoLead/DemoLeadModal';

/**
 * Exported so the questionnaire reset can carry the lead across the storage
 * wipe it performs — see useResetQuestionnaire.
 */
export const DEMO_LEAD_STORAGE_KEY = 'aldebaran-demo-lead';

export interface StoredDemoLead extends DemoLeadValues {
  savedAt: string;
  demoRequestId?: string;
}

export const saveDemoLead = (
  values: DemoLeadValues & { demoRequestId?: string },
): void => {
  try {
    sessionStorage.setItem(
      DEMO_LEAD_STORAGE_KEY,
      JSON.stringify({ ...values, savedAt: new Date().toISOString() }),
    );
  } catch {
    // Storage unavailable (private mode) — the demo still runs on the id the
    // redirect URL carries; only the restart shortcut is lost, and it falls
    // back to asking for the lead again
  }
};

export const loadDemoLead = (): StoredDemoLead | null => {
  try {
    const raw = sessionStorage.getItem(DEMO_LEAD_STORAGE_KEY);
    return raw ? (JSON.parse(raw) as StoredDemoLead) : null;
  } catch {
    return null;
  }
};

/**
 * The DemoRequest id carried by the launch redirect, kept in memory for the
 * page load that follows it.
 */
let redirectDemoRequestId: string | null = null;

export const setRedirectDemoRequestId = (demoRequestId: string): void => {
  redirectDemoRequestId = demoRequestId;
};

export const getDemoRequestId = (): string | undefined =>
  loadDemoLead()?.demoRequestId ?? redirectDemoRequestId ?? undefined;

export const clearDemoLead = (): void => {
  redirectDemoRequestId = null;
  try {
    sessionStorage.removeItem(DEMO_LEAD_STORAGE_KEY);
  } catch {
    // Storage unavailable — nothing stored, nothing to clear
  }
};
